import { useState, useEffect } from 'react';
import { fetchWithRestaurant } from '../../utils/apiHelpers';
import { useRestaurant } from '../../context/RestaurantContext';

export const useFetchJobPosts = (restaurantId = null) => {
  const [jobPosts, setJobPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { loading: restaurantLoading } = useRestaurant();

  const fetchJobPosts = async () => {
    // Don't fetch if restaurant context is still loading or no restaurant ID
    if (restaurantLoading || !restaurantId) {
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      
      const response = await fetchWithRestaurant(
        `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs/restaurant`,
        { method: 'GET' },
        restaurantId
      );

      if (!response.ok) {
        throw new Error('Failed to fetch job posts');
      }

      const data = await response.json();
      
      // Extract the actual job posts from the response
      const jobPostsArray = data.data || [];
      setJobPosts(jobPostsArray);
    } catch (error) {
      setError(error.message);
      console.error('Error fetching job posts:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchJobPosts();
  }, [restaurantId, restaurantLoading]); // Re-fetch when restaurant changes or loading state changes

  // Listen for restaurant context ready events
  useEffect(() => {
    const handleRestaurantContextReady = () => {
      fetchJobPosts();
    };

    const handleRestaurantContextUpdated = () => {
      fetchJobPosts();
    };

    window.addEventListener('restaurantContextReady', handleRestaurantContextReady);
    window.addEventListener('restaurantContextUpdated', handleRestaurantContextUpdated);
    
    return () => {
      window.removeEventListener('restaurantContextReady', handleRestaurantContextReady);
      window.removeEventListener('restaurantContextUpdated', handleRestaurantContextUpdated);
    };
  }, [restaurantId, restaurantLoading]);

  return {
    jobPosts,
    isLoading,
    error,
    refetch: fetchJobPosts
  };
};
